export const SET_BALLOTS        = 'SET_BALLOTS';
export const ADD_BALLOT         = 'ADD_BALLOT';
export const SET_BALLOT_STARTED = 'SET_BALLOT_STARTED';
export const SET_BALLOT_ENDED   = 'SET_BALLOT_ENDED';
